import { createSelector } from 'reselect';
import { RootState } from '../types';
import { initialScheduleInstallationState, ScheduleInstallationState } from './types';

export const selectScheduleInstallationDomain = (state: RootState): ScheduleInstallationState => {
  return state?.scheduleInstallation || initialScheduleInstallationState;
};
export const selectLoadingInstallationDates = createSelector(
  [selectScheduleInstallationDomain],
  (state: ScheduleInstallationState) => state.loadingInstallationDates,
);
export const selectSelectedInstallation = createSelector(
  [selectScheduleInstallationDomain],
  (state: ScheduleInstallationState) => state.selectedInstallation,
);
export const selectAvailableInstallationDates = createSelector(
  [selectScheduleInstallationDomain],
  (state: ScheduleInstallationState) => state.availableInstallationDates,
);
export const selectNoAvailableInstallationDates = createSelector(
  [selectScheduleInstallationDomain],
  (state: ScheduleInstallationState) => Object.keys(state.availableInstallationDates).length === 0,
);
export const selectPALInstallationDates = createSelector(
  [selectScheduleInstallationDomain],
  (state) => state.PALInstallationDates,
);
